// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1Vw6R","description":"PatientConsentPreview_description__G1MmQ"};